import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PlusIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path d='M16.5339 10.8307H11.5339V15.8307H9.86719V10.8307H4.86719V9.16406H9.86719V4.16406H11.5339V9.16406H16.5339V10.8307Z' />
    </svg>
));

